import Vue from 'vue'
import VueRouter from 'vue-router'

import Home from '../views/Home.vue'
import AboutUs from '../views/AboutUs.vue'
import Journalism from '../views/Journalism.vue'
import Product from '../views/Product.vue'
import ProductDetal from '../views/ProductDetal.vue'
import Index from '../views/Index.vue'
import Operation from '../views/Operation.vue'


Vue.use(VueRouter)

  const routes = [
    {
      path:'/',
      redirect:'/Index'
    },
    {
      path: '',
      name: 'Home',
      component: Home,
      children:[
        {
          path: '/Index',   
          name: 'Index', 
          component: Index   
        },
        {
          path: '/Journalism',   
          name: 'Journalism', 
          component: Journalism   //新闻动态
        },
        {
          path: '/Product',
          name: 'Product',
          component: Product
        },
        {
          path: '/ProductDetal',
          name: 'ProductDetal',
          component: ProductDetal
        },
        {
          path: '/AboutUs',
          name: 'AboutUs',
          component: AboutUs
        },
        {
          path: '/Operation',
          name: 'Operation',
          component: Operation
        },
      ]
    },


]

const router = new VueRouter({
  routes
})

export default router
